import { isNonEmptyString } from '@sniptt/guards';

import { SENTRY_DSN } from '@/error-reporting/constants/SentryDsn';
import { loadSentry } from '@/error-reporting/utils/loadSentry';

// A crash or an API error no screen plans for. Sent to Sentry when error
// alerts are on (VITE_SENTRY_DSN), ignored otherwise.
export const captureUnexpectedError = (error: unknown) => {
  if (!isNonEmptyString(SENTRY_DSN)) {
    return;
  }

  loadSentry(SENTRY_DSN)
    .then((sentryClient) => {
      sentryClient.captureException(error);
    })
    .catch(() => undefined);
};
